import styled from "styled-components";

export const ButtonContainer = styled.div`
  margin-left: 30px;
`;

export const FilterContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  /* overflow: hidden; */
  margin-bottom: 30px;

  .accordion-item {
    border: none;
    background: transparent;
  }

  .accordion-button {
    background: white;
    color: #203b34;
    font-size: 16px;
    font-weight: 600;
    padding: 24px;
    border: none;
    box-shadow: none;

    &:not(.collapsed) {
      background: white;
      color: #203b34;
      border-bottom: 1px solid #e9ecef;
    }

    &:focus {
      box-shadow: none;
      border-color: transparent;
    }

    &::after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23203b34'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
    }

    &:hover {
      background: #f8f9fa;
    }
  }

  .accordion-body {
    padding: 24px;
    background: white;
  }
`;

export const FilterButton = styled.button`
  background: #203b34;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
  }

  &:hover {
    background: #2d5347;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(32, 59, 52, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ClearButton = styled.button`
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
  }

  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
